var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStickyNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 217,
    viewBox: "0 0 217 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.917 18.0835H18.0834V40.6877H198.917V18.0835Z",
    fill: "#FFBA55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.917 18.0835V31.646H40.6875C37.0905 31.646 33.6408 30.2171 31.0974 27.6736C28.5539 25.1302 27.125 21.6805 27.125 18.0835H198.917Z",
    fill: "#FFCC66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.917 40.6875V176.313L162.75 212.479H18.0834V40.6875H198.917Z",
    fill: "#FFCC66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.917 40.6875V176.313L171.792 203.438H45.2083C40.4123 203.438 35.8128 201.532 32.4215 198.141C29.0302 194.75 27.125 190.15 27.125 185.354V40.6875H198.917Z",
    fill: "#FFDE76"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M176.313 81.3752H40.6876C39.4886 81.3752 38.3387 80.8989 37.4909 80.051C36.643 79.2032 36.1667 78.0533 36.1667 76.8543C36.1667 75.6553 36.643 74.5054 37.4909 73.6576C38.3387 72.8098 39.4886 72.3335 40.6876 72.3335H176.313C177.512 72.3335 178.661 72.8098 179.509 73.6576C180.357 74.5054 180.833 75.6553 180.833 76.8543C180.833 78.0533 180.357 79.2032 179.509 80.051C178.661 80.8989 177.512 81.3752 176.313 81.3752Z",
    fill: "#FFBA55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.313 108.5H40.6876C39.4886 108.5 38.3387 108.024 37.4909 107.176C36.643 106.328 36.1667 105.178 36.1667 103.979C36.1667 102.78 36.643 101.63 37.4909 100.783C38.3387 99.9348 39.4886 99.4585 40.6876 99.4585H176.313C177.512 99.4585 178.661 99.9348 179.509 100.783C180.357 101.63 180.833 102.78 180.833 103.979C180.833 105.178 180.357 106.328 179.509 107.176C178.661 108.024 177.512 108.5 176.313 108.5Z",
    fill: "#FFBA55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.313 135.625H40.6876C39.4886 135.625 38.3387 135.149 37.4909 134.301C36.643 133.453 36.1667 132.303 36.1667 131.104C36.1667 129.905 36.643 128.755 37.4909 127.908C38.3387 127.06 39.4886 126.583 40.6876 126.583H176.313C177.512 126.583 178.661 127.06 179.509 127.908C180.357 128.755 180.833 129.905 180.833 131.104C180.833 132.303 180.357 133.453 179.509 134.301C178.661 135.149 177.512 135.625 176.313 135.625Z",
    fill: "#FFBA55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 162.75H40.6876C39.4886 162.75 38.3387 162.274 37.4909 161.426C36.643 160.578 36.1667 159.428 36.1667 158.229C36.1667 157.03 36.643 155.88 37.4909 155.033C38.3387 154.185 39.4886 153.708 40.6876 153.708H108.5C109.699 153.708 110.849 154.185 111.697 155.033C112.545 155.88 113.021 157.03 113.021 158.229C113.021 159.428 112.545 160.578 111.697 161.426C110.849 162.274 109.699 162.75 108.5 162.75Z",
    fill: "#FFBA55"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.917 176.312L162.75 212.479V176.312H198.917Z",
    fill: "#FFBA55"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M122.062 4.521H94.9375V49.7293H122.062V4.521Z",
    fill: "#DB5669"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M122.063 4.521C122.063 43.1741 121.61 40.6877 122.063 40.6877C117.267 40.6877 112.667 38.7825 109.276 35.3912C105.884 31.9999 103.979 27.4003 103.979 22.6043V4.521H122.063Z",
    fill: "#F26674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyNote);
export default __webpack_public_path__ + "static/media/stickyNote.db46a49a8ed6095a1db971f0c59bc47f.svg";
export { ForwardRef as ReactComponent };